import { render, staticRenderFns } from "./RelatedBox.vue?vue&type=template&id=a5d06482&scoped=true&"
import script from "./RelatedBox.vue?vue&type=script&lang=ts&"
export * from "./RelatedBox.vue?vue&type=script&lang=ts&"
import style0 from "./RelatedBox.vue?vue&type=style&index=0&id=a5d06482&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5d06482",
  null
  
)

export default component.exports